module.exports = __webpack_public_path__ + "static/media/svg-3.1d3e47aa.svg";